var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ESFieldTreeselect',{attrs:{"value":_vm.value,"mappingPropsTree":_vm.mappingPropsTree,"disable-branch-nodes":false,"multiple":"","placeholder":"Select fields to fetch"},on:{"input":_vm.onSourceUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }